import React from 'react';
import { FadeIn } from './FadeIn';
import { GraduationCapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-14 md:py-20 bg-white border-t border-slate-200 relative overflow-hidden" aria-label="Llamada final a la acción" data-id="element-96">
      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-97">
        <FadeIn data-id="element-98">
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-slate-900 mb-4 leading-tight" data-id="element-99">
            Última oportunidad — <br className="hidden md:block" data-id="element-100" />
            <span className="text-amber-dark" data-id="element-101">elegí tu sistema</span>
          </h2>
          <p className="text-slate-600 text-lg mb-8 max-w-2xl mx-auto font-medium" data-id="element-102">
            🛡️ Garantía 7 días · ⚡ Acceso de inmediato · 🔒 Pago seguro
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-103">
          <div className="flex flex-col gap-5 max-w-2xl mx-auto" data-id="element-104">
            {/* Basic Option */}
            <a href="#pricing" className="flex flex-col sm:flex-row items-center justify-between gap-4 p-5 bg-surfaceLight/50 border border-slate-200 rounded-2xl hover:border-primary/50 transition-colors text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-id="element-105">
              <div className="flex-1" data-id="element-106">
                <span className="block text-base font-extrabold text-slate-900 mb-1" data-id="element-107">
                  📘 MATEMÁTICAS SIN LÁGRIMAS™ — SISTEMA COMPLETO
                </span>
                <span className="block text-xs text-slate-600 font-bold" data-id="element-108">
                  5 Tomos + 3 Bonos
                </span>
              </div>
              <div className="flex items-center gap-4 shrink-0" data-id="element-109">
                <div className="flex flex-col items-end" data-id="element-110">
                  <span className="text-slate-400 line-through text-[10px] font-bold" data-id="element-111">
                    $49.990
                  </span>
                  <span className="text-xl font-extrabold text-slate-900" data-id="element-112">
                    $19.990
                  </span>
                </div>
                <div className="py-2.5 px-4 rounded-xl font-bold text-white bg-primary hover:bg-primary-dark transition-colors uppercase tracking-wider text-xs whitespace-nowrap shadow-sm" data-id="element-113">
                  Lo quiero →
                </div>
              </div>
            </a>

            {/* Premium Option */}
            <motion.a href="#pricing" animate={{
            scale: [1, 1.02, 1]
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative flex flex-col sm:flex-row items-center justify-between gap-4 p-6 bg-amber rounded-2xl hover:bg-amber-dark transition-all duration-300 text-left shadow-glow-amber focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber" data-id="element-114">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white text-amber-dark font-extrabold px-4 py-1 rounded-full text-[10px] uppercase tracking-widest shadow-sm" data-id="element-115">
                ⭐ El más elegido
              </span>
              <div className="flex-1 mt-2 sm:mt-0" data-id="element-116">
                <span className="block text-lg font-extrabold text-white mb-1" data-id="element-117">
                  🏆 MATEMÁTICAS SIN LÁGRIMAS PREMIUM
                </span>
                <span className="block text-xs text-white/90 font-bold" data-id="element-118">
                  5 Tomos + 3 Bonos + Kit Acelerador Matemático
                </span>
                <span className="block text-[11px] text-white/80 mt-1 font-medium leading-snug" data-id="element-119">
                  Para padres que quieren el sistema completo con todas las
                  herramientas de implementación listas
                </span>
              </div>
              <div className="flex flex-col items-center sm:items-end gap-2 shrink-0 mt-3 sm:mt-0" data-id="element-120">
                <div className="flex flex-col items-center sm:items-end" data-id="element-121">
                  <span className="text-white/70 line-through text-xs font-bold" data-id="element-122">
                    $79.990 ARS
                  </span>
                  <span className="text-3xl font-extrabold text-white" data-id="element-123">
                    $29.990 ARS
                  </span>
                </div>
                <div className="py-2.5 px-5 rounded-xl font-extrabold text-amber-dark bg-white hover:bg-slate-50 transition-colors uppercase tracking-wider text-xs whitespace-nowrap shadow-sm w-full text-center" data-id="element-124">
                  → Quiero el Premium
                </div>
              </div>
            </motion.a>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-125">
          <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs text-slate-500 mt-8 font-bold" data-id="element-126">
            <div className="flex items-center gap-2" data-id="element-127">
              <span className="text-primary" aria-hidden="true" data-id="element-128">
                🛡️
              </span>
              <span data-id="element-129">Garantía 7 días</span>
            </div>
            <span className="text-slate-300 hidden sm:inline" aria-hidden="true" data-id="element-130">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-131">
              <span className="text-primary" aria-hidden="true" data-id="element-132">
                ⚡
              </span>
              <span data-id="element-133">Acceso de inmediato</span>
            </div>
            <span className="text-slate-300 hidden sm:inline" aria-hidden="true" data-id="element-134">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-135">
              <span className="text-primary" aria-hidden="true" data-id="element-136">
                🔒
              </span>
              <span data-id="element-137">Pago 100% seguro</span>
            </div>
            <span className="text-slate-300 hidden md:inline" aria-hidden="true" data-id="element-138">
              ·
            </span>
            <div className="flex items-center gap-2" data-id="element-139">
              <span className="text-primary" aria-hidden="true" data-id="element-140">
                💳
              </span>
              <span data-id="element-141">Mercado Pago | Tarjeta | Transferencia</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}